/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Search criteria for partner search
 * @export
 * @interface PartnersSearchRequest
 */
export interface PartnersSearchRequest {
    /**
     * Partner name or partner number to search for
     * @type {string}
     * @memberof PartnersSearchRequest
     */
    searchTerm?: string;
    /**
     * Maximum number of results to return. Use -1 to return all matches.
     * @type {number}
     * @memberof PartnersSearchRequest
     */
    limitResults?: number;
}

/**
 * Check if a given object implements the PartnersSearchRequest interface.
 */
export function instanceOfPartnersSearchRequest(value: object): value is PartnersSearchRequest {
    return true;
}

export function PartnersSearchRequestFromJSON(json: any): PartnersSearchRequest {
    return PartnersSearchRequestFromJSONTyped(json, false);
}

export function PartnersSearchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnersSearchRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'searchTerm': json['searchTerm'] == null ? undefined : json['searchTerm'],
        'limitResults': json['limitResults'] == null ? undefined : json['limitResults'],
    };
}

export function PartnersSearchRequestToJSON(json: any): PartnersSearchRequest {
    return PartnersSearchRequestToJSONTyped(json, false);
}

export function PartnersSearchRequestToJSONTyped(value?: PartnersSearchRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'searchTerm': value['searchTerm'],
        'limitResults': value['limitResults'],
    };
}

